var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.267 2.667c-.273 0-.546.104-.754.312L5.987 6.504 2.475 3.112A1.067 1.067 0 0 0 .992 4.647l4.267 4.12c.419.404 1.085.399 1.495-.013l4.267-4.267a1.065 1.065 0 0 0-.754-1.82",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;